<template>
<div>
    <div v-if="ie=='i'">
        <!-- 坦桑尼亚(TZA)进口提单明细 -->
        <el-card class="partItem">
            <table>
                <tbody>
                    <tr>
                        <th width="25%">进口商编号</th>
                        <td width="25%">{{billInfo.ImporterTin}}</td>
                        <th width="25%">进口模式</th>
                        <td width="25%">{{billInfo.Regime}}</td>
                    </tr>
                    <tr>
                        <th>货源国</th>
                        <td colspan="3">{{billInfo.Country}}</td>
                    </tr>
                    <tr>
                        <th>数量单位</th>
                        <td>{{billInfo.QuantityUnit}}</td>
                        <th>净重</th>
                        <td>{{billInfo.NetWeight}}</td>
                    </tr>
                    <tr>
                        <th>FOB申报价</th>
                        <td>{{billInfo.FobDeclared}}</td>
                        <th>FOB评估价</th>
                        <td>{{billInfo.FobAssessed}}</td>
                    </tr>
                    <tr>
                        <th>申报编号</th>
                        <td>{{billInfo.DeclarantTin}}</td>
                        <th>申报人</th>
                        <td>{{billInfo.DeclarantName}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>

        <el-card class="partItem">
            <div slot="header">
                <span class="headTitle">运输信息</span>
            </div>
            <table>
                <tbody>
                    <tr>
                        <th width="25%">出口国</th>
                        <td width="25%">{{billInfo.ExportCountry}}</td>
                        <th width="25%">目的国</th>
                        <td width="25%">{{billInfo.DestinationCountry}}</td>
                    </tr>
                    <tr>
                        <th>项目编号</th>
                        <td>{{billInfo.ItemNo}}</td>
                        <th>进口港</th>
                        <td>{{billInfo.PortName}}</td>
                    </tr>
                    <tr>
                        <th>船名</th>
                        <td>{{billInfo.Vessel}}</td>
                        <th>商品位置码</th>
                        <td>{{billInfo.GoodsLocationCode}}</td>
                    </tr>
                    <tr>
                        <th>商品位置名称</th>
                        <td>{{billInfo.GoodsLocationName}}</td>
                        <th>仓库代码</th>
                        <td>{{billInfo.WarehouseCode}}</td>
                    </tr>
                    <tr>
                        <th>仓库名称</th>
                        <td colspan="3">{{billInfo.WarehouseName}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>
    </div>
    <div v-if="ie=='e'">
        <!-- 坦桑尼亚(TZA)出口提单明细 -->
        <el-card class="partItem">
            <table>
                <tbody>
                    <tr>
                        <th width="25%">出口商编号</th>
                        <td width="25%">{{billInfo.ExporterTin}}</td>
                        <th width="25%">出口模式</th>
                        <td width="25%">{{billInfo.Regime}}</td>
                    </tr>
                    <tr>
                        <th>数量单位</th>
                        <td>{{billInfo.QuantityUnit}}</td>
                        <th>净重</th>
                        <td>{{billInfo.NetWeight}}</td>
                    </tr>
                    <tr>
                        <th>FOB申报价</th>
                        <td>{{billInfo.FobDeclared}}</td>
                        <th>FOB评估价</th>
                        <td>{{billInfo.FobAssessed}}</td>
                    </tr>
                    <tr>
                        <th>申报编号</th>
                        <td>{{billInfo.DeclarantTin}}</td>
                        <th>申报人</th>
                        <td>{{billInfo.DeclarantName}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>

        <el-card class="partItem">
            <div slot="header">
                <span class="headTitle">运输信息</span>
            </div>
            <table>
                <tbody>
                    <tr>
                        <th width="25%">出口国</th>
                        <td width="25%">{{billInfo.ExportCountry}}</td>
                        <th width="25%">目的国</th>
                        <td width="25%">{{billInfo.Country}}</td>
                    </tr>
                    <tr>
                        <th>项目编号</th>
                        <td>{{billInfo.ItemNo}}</td>
                        <th>进口港</th>
                        <td>{{billInfo.PortName}}</td>
                    </tr>
                    <tr>
                        <th>船名</th>
                        <td>{{billInfo.Vessel}}</td>
                        <th>商品位置码</th>
                        <td>{{billInfo.GoodsLocationCode}}</td>
                    </tr>
                    <tr>
                        <th>商品位置名称</th>
                        <td>{{billInfo.GoodsLocationName}}</td>
                        <th>仓库代码</th>
                        <td>{{billInfo.WarehouseCode}}</td>
                    </tr>
                    <tr>
                        <th>仓库名称</th>
                        <td colspan="3">{{billInfo.WarehouseName}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>
    </div>
</div>
</template>

<script>
export default {
    props:["billInfo","ie"],
    data() {
        return {

        };
    },
    methods: {
        
    },
    mounted() {

    },
};
</script>

<style lang="scss" scoped>
.partItem {
    margin-bottom: 20px;
    ::v-deep .el-card__header {
        padding: 10px 20px;
        .headTitle {
            display: inline-block;
            padding-left: 10px;
            font-size: 14px;
            border-left: 2px solid var(--themeColor);
            font-weight: bold;
        }
    }
}
table {
    width: 100%;
    border-collapse: collapse;
    tr {
        display: table-row;
        vertical-align: inherit;
        border-color: inherit;
        th,
        td {
            font-size: 12px;
            color: #666;
            height: 40px;
            border: 1px solid #eaeaea;
            text-align: center;
        }
        th {
            background-color: #f5f7fa;
            font-weight: 700;
        }
        .bg {
            background-color: var(--themeColor);
            color: #fff;
            font-weight: 700;
            opacity: 0.8;
        }
    }
}
</style>